
import { portfolioColumnActionType } from '../../constants';

const fetchPortfolioGroupInvestedAssetColumnReducer = (state = [], action) => {
    switch (action.type) {
        case portfolioColumnActionType.FETCH_PORTFOLIOS_GROUP_COLUMN:
            return action.payload;
        default:
            return state;
    }
};
export default fetchPortfolioGroupInvestedAssetColumnReducer